export default __webpack_public_path__ + "static/media/logo-loading.758ce991.gif";